// extracted by mini-css-extract-plugin
export default {"item":"vd6Be0P4wRzA2trLWE_k","itemText":"P5pXvKeb8sCb5q8LMMV7","replyDepartmentsWrapper":"Odi9o0oUDePwtFO3ioQN"};